import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../store/indexRedux";

const ManagementPage: React.FC = () => {
  const { t } = useTranslation("management");
  // This page is reachable by EVERY authenticated user (the route is no longer
  // wrapped in AdminProtectedRoute), so the gating is inverted: End Contract is
  // open to all, while Fluvius and BESS re-sign stay admin-only — their routes
  // are still behind AdminProtectedRoute, so showing those cards to a
  // non-admin would only bounce them to /overview.
  const isAdmin = useSelector((state: RootState) => state.user.user?.role === "admin");

  return (
    <div className="my-20 md:mx-14 text-primary-600">
      <h1 className="text-3xl font-semibold dark:text-white mb-16">{t("pageTitle")}</h1>
      <div className="grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-8">
        {/* End Contract — open to every authenticated user. */}
        <div className="p-8 rounded-lg border-[1px] border-base-200 dark:border-primary-800 bg-base-100 dark:bg-primary-900 flex flex-col">
          <h3 className="font-semibold text-primary-600 dark:text-white text-lg">
            {t("endContractCard")}
          </h3>
          <p className="mt-4 text-primary-400 dark:text-primary-300">
            {t("endContractCardDescription")}
          </p>
          <div className="flex items-center mt-6 gap-4">
            <NavLink
              to="/management/end-contract"
              className="px-[1.25rem] py-[0.53rem] bg-primary-600 text-white rounded-3xl text-sm hover:bg-primary-700 font-semibold flex gap-2"
            >
              {t("startNow")}
            </NavLink>
          </div>
        </div>
        {/* Admin-only: both routes are still behind AdminProtectedRoute. */}
        {isAdmin && (
          <>
            <div className="p-8 rounded-lg border-[1px] border-base-200 dark:border-primary-800 bg-base-100 dark:bg-primary-900 flex flex-col">
              <h3 className="font-semibold text-primary-600 dark:text-white text-lg">
                {t("fluviusManager")}
              </h3>
              <p className="mt-4 text-primary-400 dark:text-primary-300">
                {t("fluviusCardDescription")}
              </p>
              <div className="flex items-center mt-6 gap-4">
                <NavLink
                  to="/management/fluvius"
                  className="px-[1.25rem] py-[0.53rem] bg-primary-600 text-white rounded-3xl text-sm hover:bg-primary-700 font-semibold flex gap-2"
                >
                  {t("startNow")}
                </NavLink>
              </div>
            </div>
            <div className="p-8 rounded-lg border-[1px] border-base-200 dark:border-primary-800 bg-base-100 dark:bg-primary-900 flex flex-col">
              <h3 className="font-semibold text-primary-600 dark:text-white text-lg">
                {t("customerSwitchCard")}
              </h3>
              <p className="mt-4 text-primary-400 dark:text-primary-300">
                {t("customerSwitchCardDescription")}
              </p>
              <div className="flex items-center mt-6 gap-4">
                <NavLink
                  to="/management/customer-switch"
                  className="px-[1.25rem] py-[0.53rem] bg-primary-600 text-white rounded-3xl text-sm hover:bg-primary-700 font-semibold flex gap-2"
                >
                  {t("startNow")}
                </NavLink>
              </div>
            </div>
            <div className="p-8 rounded-lg border-[1px] border-base-200 dark:border-primary-800 bg-base-100 dark:bg-primary-900 flex flex-col">
              <h3 className="font-semibold text-primary-600 dark:text-white text-lg">
                {t("bessResignManager")}
              </h3>
              <p className="mt-4 text-primary-400 dark:text-primary-300">
                {t("bessResignCardDescription")}
              </p>
              <div className="flex items-center mt-6 gap-4">
                <NavLink
                  to="/management/bess-resign"
                  className="px-[1.25rem] py-[0.53rem] bg-primary-600 text-white rounded-3xl text-sm hover:bg-primary-700 font-semibold flex gap-2"
                >
                  {t("startNow")}
                </NavLink>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ManagementPage;
